import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { FaInstagram, FaFacebookF, FaTiktok } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import Map from "../components/homeComponents/Map";

gsap.registerPlugin(ScrollTrigger);

const Contact = () => {
  const container = useRef();
  const form = useRef();
  const [status, setStatus] = useState("Nachricht Senden");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Contact - ERA AESTHETICS";
  }, []);

  useGSAP(
    () => {
      const tl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 1 },
      });

      tl.from(".reveal-item", {
        y: 40,
        opacity: 0,
        stagger: 0.15,
      }).from(
        ".form-container",
        {
          x: 50,
          opacity: 0,
          duration: 1.2,
        },
        "-=0.8",
      );
    },
    { scope: container },
  );

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("Wird gesendet...");

    emailjs
      .sendForm(
        "service_v2a0rla",
        "template_x32wjr9",
        form.current,
        "t-Lvp6T5SE8Sk6ewD",
      )
      .then(
        () => {
          setStatus("Nachricht gesendet!");
          form.current.reset();
          setTimeout(() => setStatus("Nachricht Senden"), 3000);
        },
        (error) => {
          console.log("FAILED...", error.text);
          setStatus("Fehler. Erneut versuchen");
          setTimeout(() => setStatus("Nachricht Senden"), 3000);
        },
      );
  };

  return (
    <>
      <PageWrapper ref={container}>
        <ContactGrid>
          <InfoSide>
            <div className="header-text">
              <Label className="reveal-item">Beginne deine Reise</Label>
              <h1 className="reveal-item">Schulungsanfragen</h1>
              <p className="reveal-item">
                Ob du Fragen zu unserer Academy hast oder eine individuelle
                Behandlung buchen möchtest - unser Team steht dir mit
                fachkundiger Beratung zur Seite.
              </p>
            </div>

            <ContactMethods>
              <div className="method-item reveal-item">
                <span>E-Mail</span>
                <p>info@eraaesthetic.de</p>
              </div>
              <div className="method-item reveal-item">
                <span>Telefon</span>
                <p>+49 (0) 176 778 91414</p>
                {/* +4917677891414 */}
              </div>
              <div className="method-item reveal-item">
                <span>Standort</span>
                <p>
                  Friedrich-Hebbel-Str. 27 , <br /> 81369 München
                </p>
              </div>
            </ContactMethods>

            <SocialSection className="reveal-item">
              <span>Social Media</span>
              <div className="icon-row">
                <a href="https://www.instagram.com/era_aesthetics_muc/">
                  <FaInstagram />
                </a>
                <a href="https://www.facebook.com/share/1DUUykh4GN/?mibextid=wwXIfr">
                  <FaFacebookF />
                </a>
                <a href="https://www.tiktok.com/@era_aesthetic?_r=1&_t=ZG-93j6ohvKeMT">
                  <FaTiktok />
                </a>
                {/*<a href="#">
                <FaWhatsapp />
              </a> */}
              </div>
            </SocialSection>
          </InfoSide>

          <FormSide className="form-container">
            <StyledForm ref={form} onSubmit={sendEmail}>
              <div className="input-group">
                <label>Vollständiger Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Sarah Mustermann"
                  required
                />
              </div>
              <div className="input-group">
                <label>E-Mail Adresse</label>
                <input
                  type="email"
                  name="email"
                  placeholder="sarah@beispiel.de"
                  required
                />
              </div>
              <div className="input-group">
                <label>Telefonnummer</label>
                <input
                  type="phone"
                  name="phone"
                  placeholder="+49 176 12341234"
                  required
                />
              </div>
              <div className="input-group">
                <label>Nachricht</label>
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Erzählen Sie uns von Ihren ästhetischen Zielen..."
                  required
                />
              </div>
              <SubmitBtn type="submit" disabled={status === "Wird gesendet..."}>
                {status}
                <div className="btn-line" />
              </SubmitBtn>
            </StyledForm>
          </FormSide>
        </ContactGrid>
        <BackgroundLetter>Kontakt</BackgroundLetter>
      </PageWrapper>
      <Map />
    </>
  );
};

export default Contact;

// --- Styled Components remains the same ---
const MAIN_COLOR = "#5a5248";
const SOFT_BEIGE = "#f9f8f6";

const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${SOFT_BEIGE};
  color: ${MAIN_COLOR};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10vh 10%;
  position: relative;
  overflow: hidden;
  @media (max-width: 968px) {
    padding: 120px 5% 50px 5%;
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  width: 100%;
  max-width: 1400px;
  z-index: 2;
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

const InfoSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-family: "Playfair Display", serif;
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 400;
    line-height: 1.1;
    margin: 1.5rem 0 2rem 0;
    i {
      font-style: italic;
    }
  }
  p {
    font-size: 1.1rem;
    line-height: 1.7;
    opacity: 0.7;
    max-width: 480px;
  }
`;

const Label = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.4rem;
  font-size: 0.75rem;
  opacity: 0.5;
  display: block;
`;

const ContactMethods = styled.div`
  margin-top: 4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  .method-item {
    span {
      display: block;
      font-size: 0.7rem;
      text-transform: uppercase;
      letter-spacing: 0.1rem;
      opacity: 0.4;
      margin-bottom: 0.5rem;
    }
    p {
      font-size: 1rem;
      opacity: 1;
      font-weight: 500;
    }
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const SocialSection = styled.div`
  margin-top: 5rem;
  span {
    display: block;
    font-size: 0.8rem;
    font-style: italic;
    margin-bottom: 1.5rem;
    opacity: 0.6;
  }
  .icon-row {
    display: flex;
    gap: 25px;
    a {
      color: ${MAIN_COLOR};
      font-size: 1.2rem;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-3px);
        opacity: 0.6;
      }
    }
  }
`;

const FormSide = styled.div`
  background: #cfc0af63;
  padding: 60px;
  border-radius: 40px;
  box-shadow: 0 40px 100px rgba(90, 82, 72, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  @media (max-width: 480px) {
    padding: 40px 25px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
  .input-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    label {
      font-size: 0.75rem;
      text-transform: uppercase;
      letter-spacing: 0.15rem;
      opacity: 0.6;
    }
    input,
    textarea {
      background: #f5f0e9;
      border: 1px solid rgba(90, 82, 72, 0.1);
      padding: 18px;
      border-radius: 12px;
      font-family: inherit;
      font-size: 1rem;
      color: ${MAIN_COLOR};
      transition: border-color 0.3s;
      &:focus {
        outline: none;
        border-color: ${MAIN_COLOR};
      }
      &::placeholder {
        opacity: 0.3;
      }
    }
  }
`;

const SubmitBtn = styled.button`
  background: none;
  border: none;
  padding: 10px 0;
  color: ${MAIN_COLOR};
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  margin-top: 10px;
  position: relative;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  .btn-line {
    height: 1px;
    width: 100%;
    background: ${MAIN_COLOR};
    margin-top: 8px;
    transition: transform 0.4s;
    transform-origin: right;
  }
  &:hover .btn-line {
    transform: scaleX(0.5);
  }
`;

const BackgroundLetter = styled.div`
  position: absolute;
  right: -5%;
  bottom: -5%;
  font-size: 25vw;
  font-family: "Playfair Display", serif;
  color: rgba(90, 82, 72, 0.03);
  z-index: 1;
  pointer-events: none;
  font-weight: 700;
`;
